<template>
  <pop-up-layout 
    :title="localization.title"
    @volver="$parent.hide()"
  >
    <v-form v-model="valid" id="valid">
      <v-row class="px-6 pb-6" justify="center" align="center">
      <v-col cols="10" sm="8">
      <v-text-field
        v-model="passwordActual" id="passwordActual"
        :name="password"
        :type="showPassword0 ? 'text' : 'password'"
        :append-icon="showPassword0 ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="showPassword0 = !showPassword0"
        :label="localization.actual"
        required
      ></v-text-field>
      <v-text-field
        v-model="password" id="password"
        :name="password"
        :rules="passwordRules"
        :type="showPassword1 ? 'text' : 'password'"
        :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="showPassword1 = !showPassword1"
        :label="localization.contraseña"
        required
      ></v-text-field>
      <v-text-field
        v-model="passwordRepetida" id="passwordRepetida"
        :name="passwordRepetida"
        :rules="passwordRepetidaRules"
        :type="showPassword2 ? 'text' : 'password'"
        :append-icon="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="showPassword2 = !showPassword2"
        :label="localization.repetir"
        required
      ></v-text-field>
      <v-layout justify-center style="padding-top:30px">
        <v-btn :disabled="!valid || desactivarBoton" :loading="desactivarBoton" color="primary" @click="modificarPassword()">
          {{localization.modificar}}
        </v-btn>
      </v-layout>
      </v-col>
      </v-row>
    </v-form>
  </pop-up-layout>    
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      desactivarBoton: false,      
      usuario: {},
      password: '',
      passwordRepetida: '',
      passwordActual: '',
      valid: false,
      passwordRules: [
        (v) => !!v || this.$t('rules.required'),
        (v) => v.length >= 8 || this.$t('contraseñaMinimoCaracteres'),
        (v) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
          return (
            pattern.test(v) ||
              this.$t('contraseñaPatron')
          )
        }
      ],
      passwordRepetidaRules: [
        (v) => !!v || this.$t('rules.required'),
        (v) => v === this.password || this.$t('contraseñasNoCoinciden'),
        (v) => v.length >= 8 || this.$t('contraseñaMinimoCaracteres'),
        (v) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
          return (
            pattern.test(v) ||
              this.$t('contraseñaPatron')
          )
        }
      ],
      showPassword0: false,
      showPassword1: false,
      showPassword2: false
    }
  },
  async created () {
    this.loading = true
    // cargar aquí las cosas que hubiera que cargar
    this.loading = false
  },
  computed: {
    ...mapGetters({
      usuarioStore: 'login/usuario'
    }),
    localization () {
      return this.$t('sectionPerfil.cambiarPassword')
    }
  },
  methods: {
    ...mapActions({
      modificarPasswordApi: 'login/modificarPassword',
      addAlert: 'alerts/add'
    }),
    modificarPassword () {
      this.desactivarBoton = true
      this.modificarPasswordApi({
        password: this.password,
        passwordActual: this.passwordActual
      })
        .then(() => {
          this.addAlert({texto: this.$t('contraseñaModificada'), color: 'success'})
          this.$router.push({
            name: 'home'
          })
          this.desactivarBoton = false
          this.$parent.hide()
      
        })
        .catch((error) => {
          this.desactivarBoton = false
          if (!error.code || error.code !== 1) {
            this.addAlert({texto: error.message, color: 'error'})
          }
        })
    }
  },
  watch: {
    cambiado () {
      this.$emit('cambiado', this.cambiado)
    }
  }
}
</script>